/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: bd23c504 (Thu Jun 11 17:44:43 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  ProgramInviteFamilyOptionsResponsePrograms,
  ProgramInviteFamilyOptionsResponseProgramsFromJSON,
  ProgramInviteFamilyOptionsResponseProgramsToJSON,
} from './'

/**
 *
 * @export
 * @interface ProgramInviteFamilyOptionsResponse
 */
export interface ProgramInviteFamilyOptionsResponse {
  /**
   * The programs a user can send family invites.
   * @type {Array<ProgramInviteFamilyOptionsResponsePrograms>}
   * @memberof ProgramInviteFamilyOptionsResponse
   */
  programs: Array<ProgramInviteFamilyOptionsResponsePrograms>
}

export function ProgramInviteFamilyOptionsResponseFromJSON(
  json: any
): ProgramInviteFamilyOptionsResponse {
  return ProgramInviteFamilyOptionsResponseFromJSONTyped(json, false)
}

export function ProgramInviteFamilyOptionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProgramInviteFamilyOptionsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programs: (json['programs'] as Array<any>).map(
      ProgramInviteFamilyOptionsResponseProgramsFromJSON
    ),
  }
}

export function ProgramInviteFamilyOptionsResponseToJSON(
  value?: ProgramInviteFamilyOptionsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programs: (value.programs as Array<any>).map(
      ProgramInviteFamilyOptionsResponseProgramsToJSON
    ),
  }
}
